import { render, staticRenderFns } from "./AIAHeaderText.vue?vue&type=template&id=5e158653&"
import script from "./AIAHeaderText.vue?vue&type=script&lang=js&"
export * from "./AIAHeaderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports